import {
  ApiCartReplaceEmailInCartRequestedAction,
  apiCartReplaceEmailInCartFailed,
  apiCartReplaceEmailInCartSucceeded
} from '../../../api/cart/replaceEmailInCartApi';
import { call, put } from 'typed-redux-saga';
import replaceEmailInCartAction, {
  ReplaceEmailInCartActionInput,
  ReplaceEmailInCartActionResult
} from '@spa/lib/actions/cart/replaceEmailInCartAction';

function* replaceEmailInCartSaga({
  payload: { actionId: requestedActionId, customOrderType, email, parentActionId }
}: ApiCartReplaceEmailInCartRequestedAction): Generator {
  try {
    const input: ReplaceEmailInCartActionInput = { customOrderType, email };
    const { cartId, result }: ReplaceEmailInCartActionResult = yield* call(
      replaceEmailInCartAction,
      'replaceEmailInCartAction',
      input
    );
    yield* put(
      apiCartReplaceEmailInCartSucceeded({
        cartId,
        parentActionId,
        requestedActionId,
        result
      })
    );
  } catch {
    yield* put(
      apiCartReplaceEmailInCartFailed({
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default replaceEmailInCartSaga;
